import React, { useState } from 'react'
import { ThemeProvider } from 'styled-components'
import Logo from './logo/logo.component'
import Toggler from './toggler/toggler.component'
import * as Styles from './side-menu.styles'

type Props = {
  children: JSX.Element
  collapsed: boolean
  useRouter: boolean
}

const SideMenu: React.FC<any> = (props: Props) => {
  const [collapsed, setCollapsed] = useState(props.collapsed)

  const onToggle = (newState: boolean): void => setCollapsed(newState)

  return (
    <ThemeProvider theme={{ collapsed: collapsed }}>
      <Styles.SideMenu>
        <Toggler collapsed={collapsed} onToggle={onToggle} />
        <Logo compact={collapsed} />
        { props.children }
      </Styles.SideMenu>
    </ThemeProvider>
  )
}

export default SideMenu
